<template>
  <div class="mall">
    <div v-if="isLoaded" class="page" :class="{ 'page--list': profiles.length > 0 }">
      <!-- 등록된 환자 프로필이 없을 때: 환자 등록 안내 -->
      <template v-if="profiles.length === 0">
        <MallProfileEmpty />
        <MallBottomBar
          :buttons="emptyButtons"
          @click="onEmptyButtonClick"
        />
      </template>

      <!-- 구매할 환자 프로필 선택 -->
      <template v-else>
        <MallHeader
          @back-click="goBack"
          @add-profile-click="goRegister"
        />
        <MallProfileSelect
          :profiles="profiles"
          :selectedProfileId="selectedProfileId"
          @select="onSelectProfile"
        />
        <MallBottomBar
          :buttons="purchaseButtons"
          @click="goPurchase"
        />
        <!-- 구매정보 확인: 저장해야 프로필 선택 완료 -->
        <MallPurchaseInfoSheet
          v-if="sheetProfileId !== null"
          :info="sheetInfo"
          :reductionOptions="reductionOptions"
          @close="closePurchaseInfoSheet"
          @save="savePurchaseInfo"
        />
      </template>
    </div>
  </div>
</template>

<script>
import Constant from '@/constant'
import mall from '@/utilities/mall.js'
import MallHeader from '@/components/new/molecules/MallHeader.vue'
import MallBottomBar from '@/components/new/molecules/MallBottomBar.vue'
import MallProfileSelect from '@/components/new/organisms/MallProfileSelect.vue'
import MallProfileEmpty from '@/components/new/organisms/MallProfileEmpty.vue'
import MallPurchaseInfoSheet from '@/components/new/organisms/MallPurchaseInfoSheet.vue'

export default {
  name: 'Mall',
  components: {
    MallHeader,
    MallBottomBar,
    MallProfileSelect,
    MallProfileEmpty,
    MallPurchaseInfoSheet,
  },
  data() {
    return {
      // 환자 프로필 목록 (FETCH_PROFILES 응답을 화면용으로 변환)
      // 빈 배열([])이면 환자 등록 안내 화면이 노출됨
      profiles: [],
      // 프로필 목록을 받기 전에는 빈 화면(환자 등록 안내)이 깜빡이지 않도록 아무것도 그리지 않음
      isLoaded: false,
      selectedProfileId: null,
      // TODO: 추후 API 연동 - 경감 대상 목록 조회
      reductionOptions: [
        { value: 'none', label: '해당 없음' },
        { value: 'basic', label: '기초생활 수급자' },
        { value: 'nearPoor', label: '차상위 계층' },
      ],
      // 구매정보 확인 화면을 띄운 프로필 id (null이면 닫힘)
      sheetProfileId: null,
      emptyButtons: [
        { key: 'later', label: '다음에 하기', type: 'secondary' },
        { key: 'register', label: '환자 등록하기', type: 'primary' },
      ],
    }
  },
  computed: {
    purchaseButtons() {
      return [
        { key: 'purchase', label: '구매 하러 가기', type: 'primary', disabled: this.selectedProfileId === null },
      ]
    },
    // 구매정보 저장 API가 없어 기기에 저장된 값으로 채움
    // TODO: 구매정보 저장 / 조회 API가 생기면 교체
    sheetInfo() {
      return mall.getPurchaseInfo(this.sheetProfileId) || {
        prescriptionDays: '',
        reductionType: 'none',
        usesInsulinPump: false,
      }
    },
  },
  mounted() {
    ChannelIO('shutdown')
    this.fetchProfiles()
  },
  methods: {
    fetchProfiles() {
      var token = mall.getAccessToken()
      if (!token) {
        mall.goLogin(this.$router)
        return
      }
      this.$store.dispatch(Constant.FETCH_PROFILES, { token: token })
        .then((profiles) => {
          this.profiles = (profiles || []).map(item => this.toProfileView(item))
          this.isLoaded = true
        })
        .catch(() => {
          // FETCH_PROFILES는 오류 내용 없이 reject 되므로 토큰 오류로 보고 다시 로그인
          mall.goLogin(this.$router)
        })
    },
    toProfileView(item) {
      var profile = item.profile
      return {
        id: profile.id,
        name: profile.name,
        // TODO: 관계(본인/가족)는 API에 없어 미노출
        relation: '',
        birth: mall.formatBirth(profile.registration_number),
        diseaseType: mall.diseaseTypeName(profile.diabetes_type),
        isDelegated: !!(item.delegation_info && item.delegation_info.is_delegated),
        // TODO: 구매정보 확인 화면 노출 여부 (현재는 모두 노출)
        showPurchaseInfo: true,
      }
    },
    goBack() {
      this.$router.push({ path: '/home' })
    },
    goRegister() {
      this.$router.push({ path: '/register' })
    },
    onEmptyButtonClick(key) {
      if (key === 'register') {
        this.goRegister()
      } else {
        this.goBack()
      }
    },
    onSelectProfile(profileId) {
      var profile = this.profiles.find(p => p.id === profileId)
      if (profile && profile.showPurchaseInfo) {
        this.sheetProfileId = profileId
        return
      }
      this.selectedProfileId = profileId
    },
    closePurchaseInfoSheet() {
      this.sheetProfileId = null
    },
    savePurchaseInfo(info) {
      // 장바구니 / 결제 금액 계산(처방일수, 경감 대상)에 쓰임
      mall.setPurchaseInfo(this.sheetProfileId, Object.assign({}, info))
      this.selectedProfileId = this.sheetProfileId
      this.sheetProfileId = null
    },
    goPurchase() {
      // TODO: 추후 API 연동 - 선택한 프로필(selectedProfileId)을 기준 프로필로 저장
      this.$router.push({ path: '/mall/shop', query: { profileId: this.selectedProfileId } })
    },
  },
}
</script>

<style scoped>
  .mall {
    display: flex;
    width: 100%;
    min-height: 100vh;
    justify-content: center;
    align-items: flex-start;
  }
  .page {
    width: 100%;
    background: #FFF;
  }
  /* 하단 고정 버튼 영역(90px)에 마지막 카드가 가려지지 않도록 */
  .page--list {
    padding-bottom: 90px;
  }
  @media (min-width: 600px) {
    .page {
      width: 600px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/new/Mall.vue